<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="breadcrumb-com">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            $t("home")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/news' }">
            {{ $t("news") }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            {{
              newsDetailData !== undefined
                ? newsDetailData.name || newsDetailData.title
                : ""
            }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content">
        <div class="info-box">
          <div class="title">
            {{
              newsDetailData !== undefined
                ? newsDetailData.name || newsDetailData.title
                : ""
            }}
          </div>
          <div
            class="details-body"
            v-html="
              newsDetailData !== undefined
                ? newsDetailData.content || newsDetailData.updatecontent
                : ''
            "
          ></div>
        </div>
        <div class="more">
          <div class="more-icon">
            <img src="~@a/img/time.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      newsDetailData: undefined,
      swiperImgs: []
    };
  },
  components: {
    Swiper
  },
  created() {
    this.topingAll();
    this.newsDetail({
      id: this.$route.query.id
    });
  },
  methods: {
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 2)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsCasesCat(params) {
      API.newsCasesCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
            onClose: () => {}
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsDetail(params) {
      API.newsDetail(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "newsDetailData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softDetail(params) {
      API.softDetail(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "newsDetailData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.breadcrumb-com {
  display: flex;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid var(--color-line);
}

.content {
  color: var(--color-light-black);
  font-size: 16px;
  line-height: initial;

  .title {
    text-align: center;
    font-size: 28px;
    padding: 40px 10px;
    font-weight: bold;
  }

  p {
    line-height: 40px;
  }

  .more {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;

    .more-icon {
      width: 20px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .breadcrumb-com {
    padding: 0 10px;
  }
}
</style>
